// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Pvb","desc":"e_Qvb","imageContainer":"e_Rvb","title":"e_Svb","score":"e_Tvb","seeAlso":"e_Uvb"};